class OlanaMegaNav extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;

    this.dataset.ready = 'true';
    this.categories = Array.from(this.querySelectorAll('[data-olana-category]'));
    this.panels = Array.from(this.querySelectorAll('[data-olana-panel]'));

    this.categories.forEach((category) => {
      const activate = () => this.activate(category.dataset.olanaIndex);
      category.addEventListener('mouseenter', activate);
      category.addEventListener('focus', activate);
    });
  }

  activate(index) {
    this.categories.forEach((category) => {
      const active = category.dataset.olanaIndex === index;
      category.classList.toggle('is-active', active);
      category.setAttribute('aria-expanded', active ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const active = panel.dataset.olanaIndex === index;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
  }
}

if (!customElements.get('olana-meganav')) {
  customElements.define('olana-meganav', OlanaMegaNav);
}
